import UIkit from './UIkit';

const initPortfolioSlideshow = () => {
  const portfolioContainer = document.querySelector('.portfolio-slideshow .uk-slider');
  
  if (portfolioContainer) {
    UIkit.util.on(portfolioContainer, 'beforeitemshow', function (e) {
      const index = parseInt(e.target.dataset.id) + 1;
      const currentSlide = document.querySelector('.current-slide');
      let totalSlides = document.querySelector('.total-slides');
      
      totalSlides = totalSlides.innerHTML;
      currentSlide.innerHTML = index.toString().padStart(2, '0');
    });
  }
};

export default initPortfolioSlideshow;
